import { defaultApiState } from "@/store/general.types";
import { StudyState } from "./study.types";

export const studyState: StudyState = {
    getCitationUploadSignedUrl: defaultApiState,
    getBulkCitationUploadSignedUrls: defaultApiState,
    getProcessingCitationFiles: defaultApiState,
    getProcessingFilesCounts: defaultApiState,
    getUserProcessingFileStatusCounts: defaultApiState,
    untrackFilesStatus: defaultApiState,
    untrackFilesByStatus: defaultApiState,
    getFailedImports: defaultApiState,
    getImportedCitationFiles: defaultApiState,
    deleteImportedCitationAndFile: defaultApiState,
    downloadCorruptionReport: defaultApiState,
    getUserLatestFailedImport: defaultApiState,
    createStudyNote: defaultApiState,
    updateStudyNote: defaultApiState,
    getStudyNotes:defaultApiState,
    exportCitations:defaultApiState,
    getAuthorsByProject: defaultApiState,
    getPublicationTypes:defaultApiState,
    enterRecord:defaultApiState,
}